<template>
  <Main>
    <InsuranceCompanyTable />
  </Main>
</template>
<script>
import InsuranceCompanyTable from "../components/InsuranceCompanyTable";
export default {
  components: {
    InsuranceCompanyTable
  }
};
</script>
